import React, { useState, useRef, useEffect } from "react";

// SG-2164: per-widget "how should this render" control — Line / Bar / KPI. Only shown for
// widgets that have a seriesKey (widgetHasGraph in utils/widgetConstants.js) — no-series widgets
// (TASKS_DUE, AVG_CALL_DURATION, INMAILS_SENT, etc.) never get this option at all.
// Persisted the same way Audience Scope is — via dashboardV2Store.updateWidgetVisualization →
// PUT /cm/dashboard/updateDashboard — no new endpoint.
const VISUALIZATION_OPTIONS = [
  { id: "LINE", label: "Line chart" },
  { id: "BAR", label: "Bar chart" },
  { id: "KPI", label: "KPI (Numeric summary)" }
];

const VisualizationTypePopover = ({ visualization, defaultVisualization = "LINE", onClose, onSave }) => {
  // SG-2164: fall back to the widget's inherent chart type (defaultVisualization) rather than a
  // hardcoded "LINE" — for widgets that render bar by default (Call Outcomes, Contact Stages) and
  // were built before this feature existed (visualization === null), so the pre-selected radio
  // matches what's actually on screen instead of always showing "Line".
  const [selected, setSelected] = useState(visualization || defaultVisualization);
  const ref = useRef(null);

  useEffect(() => {
    const handler = e => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  const handleSave = () => {
    onSave(selected);
    onClose();
  };

  return (
    <div ref={ref} className="audienceScopePopover visualizationTypePopover">
      <p className="audienceScopePopoverTitle">Visualization type</p>
      <div className="audienceScopeOptions">
        {VISUALIZATION_OPTIONS.map(opt => (
          <div
            key={opt.id}
            className={`audienceScopeOption${selected === opt.id ? " audienceScopeOptionActive" : ""}`}
            onClick={() => setSelected(opt.id)}
          >
            <span className="audienceScopeOptionRadio" />
            <div>
              <p className="audienceScopeOptionLabel">{opt.label}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="audienceScopeFooter">
        <button type="button" className="audienceScopeCancelBtn" onClick={onClose}>
          Cancel
        </button>
        <button type="button" className="audienceScopeSaveBtn" onClick={handleSave}>
          Save
        </button>
      </div>
    </div>
  );
};

export default VisualizationTypePopover;
